<template>
  <v-card>
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <vue-gmap
      :center="markerCenter"
      :zoom="10"
      style="width: 100%; height: 800px;"
    >
      <!-- <gmap-custom-marker
          alignment="bottomright"
          key="supermarker"
          :marker="markerCenter"
        >
          <div class="card" @click="e => e.stopPropagation()">
            <img :class="animation" class="icon" :src="src" height="30" />
          </div>
        </gmap-custom-marker> -->
      <gmap-custom-marker
        v-for="marker in mayaks"
        :key="marker.id"
        alignment="center"
        :marker="{ lat: marker.lat, lng: marker.lng }"
      >
        <div class="live-html">
          <v-icon small :color="returnStateColor(marker)">mdi-car</v-icon>
          {{ findCar(marker) }} - {{ marker.v }} км/ч
        </div>
      </gmap-custom-marker>
    </vue-gmap>
  </v-card>
</template>

<script>
// fb99db93d09148499e8f93dc8420d639
// 1Arcan@
// Google
// AIzaSyBI4BMTVdrBw_p4rjxkseNpQ_F4x_sW1LE
import { components } from "gmap-vue";
const { MapLayer: Map } = components;
import GmapCustomMarker from "vue2-gmap-custom-marker";
// import firebase from "firebase/app";
// import "firebase/auth";
var md5 = require("md5");
export default {
  created() {
    let self = this;
    if (this.$store.getters.isLoggedIn) {
      if (
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.starline_app_id &&
        this.$store.getters.getCompany.company.starline_secret
      ) {
        this.isLoading = true;
        let secret = md5(self.$store.getters.getCompany.company.starline_secret)
        this.axios({
          method: "post",
          url: `https://id.starline.ru/apiV3/application/getToken?appId=${self.$store.getters.getCompany.company.starline_app_id}&secret=${secret}`,
          headers: {
            "Access-Control-Allow-Origin": "*",
            'Content-Type': 'application/json',
          }
        })
          .then(response => {
            if (response.state == 1) {
              console.log(response.desc.code)
            } else {
              this.$notify(this.$t('errors.beacon_load'), response.desc.message, "warning", 5000);
              console.log(response.desc.message);
            }
            // this.imeis = response.data;
            // this.axios({
            //   method: "post",
            //   url: `https://gprs.autofon.ru:9443/jsonapi/laststates/?key=${self.$store.getters.getCompany.company.autofon_token}&pwd=${self.$store.getters.getCompany.company.autofon_pwd}`,
            //   headers: {
            //     "Content-Type": "application/json"
            //   }
            // })
            //   .then(response => {
            //     self.mayaks = response.data;
            //   })
            //   .catch(error => {
            //     self.setError(error, "Ошибка загрузки данных маяков");
            //     console.log(error);
            //   });
          })
          .catch(error => {
            this.setError(error, this.$t('errors.beacon_load'));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t('errors.beacon_load'), this.$t('errors.beacon_load_text'), "warning", 5000);
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  mounted() {
    let self = this;
    if (
      this.$store.getters.getCompany.company &&
      this.$store.getters.getCompany.company.starline_app_id &&
      this.$store.getters.getCompany.company.starline_secret
    ) {
      this.pollData();
    } else {
      this.$notify(this.$t('errors.beacon_load'), this.$t('errors.beacon_load_text'), "warning", 5000);
    }
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  data() {
    return {
      mayaks: [],
      imeis: [],
      marker: {
        lat: 50.60229509638775,
        lng: 3.0247059387528408
      },
      batchCount: 10,
      html: "<center><h2>This is <u>live</u> html marker 🔥</h2><center>",
      infinite: true,
      selectedAnimation: "",
      zA: 50,
      zB: 51,
      testText: null,
      markerCenter: {
        lat: 54.6272265,
        lng: 20.0571581
      },
      addWeather: false,
      addMode: false,
      markers: [],
      ids: 0,
      alignment: "top",
      batchMarkers: [],
      tools: true,
      polling: null,
      isLoading: false
    };
  },
  computed: {
    animation() {
      const infinite = this.infinite ? "infinite" : "";
      return `animated ${infinite} ${this.selectedAnimation}`;
    },
    src() {
      return this.testText
        ? this.testText
        : "https://vuejs.org/images/logo.png";
    }
  },
  methods: {
    pollData() {
      let self = this;
      this.polling = setInterval(() => {
        self.updateMayak();
      }, 5000);
    },
    updateMayak() {
      // let self = this
      // this.axios({
      //   method: "post",
      //   url: `https://gprs.autofon.ru:9443/jsonapi/objects/?key=${self.$store.getters.getCompany.company.autofon_token}&pwd=${self.$store.getters.getCompany.company.autofon_pwd}`,
      //   headers: {
      //     "Content-Type": "application/json"
      //   }
      // })
      //   .then(response => {
      //     console.log('objects', response.data)
      //     this.imeis = response.data;
      //     this.axios({
      //       method: "post",
      //       url: `https://gprs.autofon.ru:9443/jsonapi/laststates/?key=${self.$store.getters.getCompany.company.autofon_token}&pwd=${self.$store.getters.getCompany.company.autofon_pwd}`,
      //       headers: {
      //         "Content-Type": "application/json"
      //       }
      //     })
      //       .then(response => {
      //         console.log('laststates', response.data)
      //         self.mayaks = response.data;
      //       })
      //       .catch(error => {
      //         self.setError(error, "Ошибка загрузки данных маяков");
      //         console.log(error);
      //       });
      //   })
      //   .catch(error => {
      //     this.setError(error, "Ошибка загрузки данных маяков");
      //     console.log(error);
      //   })
      //   .finally(() => (this.isLoading = false));
    },
    findCar(marker) {
      let result = this.imeis.find(imei => imei.id == marker.id);
      if (result) {
        return result.desc;
      } else {
        return marker.id;
      }
    },
    returnStateColor(marker) {
      if (marker.on == 1) {
        return "success";
      } else if (marker.on == 0) {
        return "warning";
      } else {
        return "secondery";
      }
    },
    // displayTools(value) {
    //   this.tools = value;
    // },
    // deleteMarker(i) {
    //   this.markers.splice(i, 1);
    // },
    // onMapClick(event) {
    //   if (this.addMode) {
    //     this.markers.push({
    //       _id: this.ids++,
    //       latitude: event.latLng.lat(),
    //       longitude: event.latLng.lng(),
    //       weather: this.addWeather,
    //       alignment: this.alignment
    //     });
    //     this.addMode = false;
    //   }
    // },
    addbatch() {
      this.batchMarkers = [];
      for (let i = 0; i < this.batchCount; i++) {
        this.batchMarkers.push({
          lat: `48.1${String(parseInt(Math.random() * 100000))}`,
          lng: `-1.7${String(parseInt(Math.random() * 100000))}`
        });
      }
      this.markerCenter = {
        lat: 48.1030572,
        lng: -1.7065389
      };
    }
  },
  components: {
    GmapCustomMarker,
    "vue-gmap": Map
  }
};
</script>

<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css";
.vue-map-container {
  height: 100%;
  padding: 0px;
  margin: 0px;
}
.live-html {
  padding: 5px;
  border: 1px solid #aaa;
  border-radius: 4px;
  box-shadow: 3px 3px 3px grey;
  /* min-height: 200px;
  min-width: 200px; */
  background-color: #fafafa;
}
.zindex {
  padding: 5px;
  border: 1px solid #aaa;
  border-radius: 4px;
  box-shadow: 3px 3px 3px grey;
  min-height: 100px;
  min-width: 100px;
  font-size: 1.3em;
}
.zindex-a {
  background-color: #eb7bff;
}
.zindex-b {
  background-color: #17e2b8;
}
.alignment {
  right: 10px;
  z-index: 1000;
  padding: 4px;
  top: 15px;
  border-radius: 5px;
}
.weather {
  top: 70px;
}
.icon-sm {
  padding: 3px;
  border-radius: 4px;
}
.animate-panel {
  padding: 7px;
  right: 10px;
  top: 150px;
  height: 100px;
  width: 250px;
  z-index: 100;
}
.live-editor {
  right: 10px;
  top: 270px;
  z-index: 1000;
  height: 100px;
  width: 250px;
  border: 1px solid #ccc;
}
.live-editor textarea {
  width: 100%;
  height: 100%;
}
.add-marker {
  padding: 8px;
  font-size: 1.3em;
}
.batch-cluster {
  right: 0px;
  top: 400px;
  width: 270px;
  height: 40px;
  border-radius: 5px;
  z-index: 100;
}
.card-tools {
  right: 5px;
  top: 5px;
  padding: 8px;
  background-color: #fafafa;
  border: 1px solid #bbb;
  width: 270px;
  z-index: 100;
  position: absolute;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
}
.batch-cluster > input,
.batch-cluster > button {
  margin-left: 10px;
  margin-right: 10px;
}
.hide-tool {
  background-color: #fafafa;
  border: 1px solid #bbb;
  font-size: 1.3em;
}
.show-tool {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: #fafafa;
  border: 1px solid #bbb;
  font-size: 1.3em;
  z-index: 100;
}
</style>
